import { render, staticRenderFns } from "./EditContractOwnerSidebar.vue?vue&type=template&id=61a1274c"
import script from "./EditContractOwnerSidebar.vue?vue&type=script&lang=js"
export * from "./EditContractOwnerSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports